<template>
  <div class="mobile-menu-container">
    <!-- ヘッダー -->
    <header class="header">
      <div class="header-title">スマオーダーモバイル</div>
      <div class="header-actions">
        <button class="header-btn" @click="$router.push('/checkout-confirm')">
          <i class="fa-solid fa-receipt"></i>
          <span>会計確認</span>
        </button>
        <button class="header-btn call-btn" @click="callStaff">
          <i class="fa-solid fa-bell"></i>
          <span>呼び出し</span>
        </button>
      </div>
    </header>

    <!-- カテゴリタブ -->
    <div class="category-tabs-wrapper">
      <div class="category-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-btn"
          :class="{ active: activeTabId === tab.id }"
          @click="selectTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      </div>
    </div>

    <!-- メニューリスト -->
    <main class="menu-content">
      <div class="menu-grid" :class="{ 'list-layout': isDrinkOrAlcolTab }">
        <div
          v-for="item in items"
          :key="item.id"
          class="menu-card"
          :class="{ 'sold-out': item.isSoldOut }"
          @click="showDetail(item)"
        >
          <div v-if="item.isSoldOut" class="sold-out-overlay">
            <span>SOLD OUT</span>
          </div>
          <div class="card-image" v-if="!isDrinkOrAlcolTab">
            <img :src="item.image_url || '/img/menu/no_image.png'" :alt="item.label" />
          </div>
          <div class="card-body">
            <h3 class="item-name">{{ item.label }}</h3>
            <div class="item-footer">
              <span class="item-price">
                <span v-if="item.price === 0">無料</span>
                <span v-else>
                  {{ Math.round(item.price / 1.1).toLocaleString() }}円
                  <span class="tax-included-price">(税込{{ item.price.toLocaleString() }}円)</span>
                </span>
              </span>
            </div>
          </div>
          <!-- 数量バッジ (カートに入っている場合) -->
          <div v-if="getItemQuantity(item.id) > 0" class="quantity-badge">
            {{ getItemQuantity(item.id) }}
          </div>
        </div>
      </div>
    </main>

    <!-- フッター -->
    <footer class="footer" :class="{ expanded: isFooterExpanded }">
      
      <!-- 開閉トリガー (共通化) -->
      <div class="footer-trigger-tab" @click="isFooterExpanded = !isFooterExpanded">
        <i class="fa-solid" :class="isFooterExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
      </div>

      <!-- 拡大エリア (カート詳細) -->
      <div class="footer-expanded-content" v-if="isFooterExpanded">
        <div class="expanded-title">カート一覧</div>
        <!-- スクロール可能なリストエリア -->
        <div class="cart-details-scroll-area">
          <div v-if="cart.length === 0" class="empty-cart-message">
            カートに商品が入っていません
          </div>
          <div v-else class="cart-list">
            <div v-for="(item, index) in cart" :key="index" class="cart-item">
              <div class="cart-item-info">
                <div class="cart-item-name">{{ item.label }}</div>
                <div class="cart-item-price">
                  <span v-if="item.price === 0">無料</span>
                  <span v-else>
                    {{ Math.round(item.price / 1.1).toLocaleString() }}円
                    <span class="tax-included-price">(税込{{ item.price.toLocaleString() }}円)</span>
                  </span>
                </div>
              </div>
              <div class="cart-item-controls">
                <button class="qty-btn minus" @click="decreaseQuantity(item)">
                  <i class="fa-solid fa-minus"></i>
                </button>
                <span class="qty-display">{{ item.quantity }}</span>
                <button class="qty-btn plus" @click="increaseQuantity(item)">
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- メインフッターコンテンツ -->
      <div class="footer-main">
        <div class="footer-left-group">
          <div class="total-info">
            <span class="total-label">合計</span>
            <span class="total-price">
              {{ Math.round(totalPrice / 1.1).toLocaleString() }}円
              <span class="tax-info">(税込{{ totalPrice.toLocaleString() }}円)</span>
            </span>
          </div>
          <!-- 飲み放題タイマー -->
          <div v-if="remainingTime !== ''" class="drink-plan-timer">
            <p>
              <span v-if="typeof remainingTime === 'number'">
                飲み放題<br>残り <span class="time-value">{{ remainingTime }}</span> 分
              </span>
              <span v-else>
                {{ remainingTime }}
              </span>
            </p>
          </div>
        </div>
        <button class="confirm-btn" @click="confirmOrder" :disabled="cart.length === 0">
          注文確定
        </button>
      </div>
    </footer>

    <!-- カートモーダル (簡易表示) -->
    <!-- 必要であれば追加 -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MenuMobile',
  data() {
    return {
      isFooterExpanded: false,
      activeTabId: null,
      tabs: [],
      items: [],
      tablesessions: [],
      diningTableID: localStorage.getItem('diningTableID'),
      uuid: localStorage.getItem('deviceUUID'),
      remainingTime: '',
      timerId: null,
    };
  },
  created() {
    // Check for NON-mobile device
    if (window.innerWidth >= 768) {
      this.$router.replace('/menu');
      return;
    }

    this.getMenus();
    this.getTableSessions();
  },
  beforeUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState('cart', { cart: 'items', drinkPlanEndTime: 'drinkPlanEndTime' }),

    totalPrice() {
      const historyItems = this.$store.state.orderhistory.items;
      return historyItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    },
    activeTab() {
      if (!this.activeTabId || !this.tabs.length) {
        return null;
      }
      return this.tabs.find((tab) => tab.id === this.activeTabId);
    },
    isDrinkOrAlcolTab() {
      if (!this.activeTab || !this.activeTab.name) {
        return false;
      }
      const name = this.activeTab.name.toLowerCase();
      return name === 'alcohol' || name === 'drink' || name === 'other-alcohol';
    },
  },
  watch: {
    'cart.length': function onCartLengthChange(newLength) {
      if (newLength === 0) {
        this.isFooterExpanded = false;
      }
    },
    drinkPlanEndTime: {
      handler(newValue) {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
        }
        if (newValue) {
          this.startTimer();
        } else if (this.remainingTime === 0) {
          // 何もしない（0分を維持）
        } else {
          this.remainingTime = '';
        }
      },
      immediate: true,
    },
    $route: {
      handler(to) {
        // MenuMobileページに戻ってきたときにタイマーの状態を同期する
        if (to.path === '/menu-mobile') {
          if (this.drinkPlanEndTime && !this.timerId) {
            this.startTimer();
          } else if (!this.drinkPlanEndTime && this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
            // 既に0なら維持、それ以外は空にする
            if (this.remainingTime !== 0) this.remainingTime = '';
          }
        }
      },
      immediate: true, // ページが直接ロードされた場合にも実行されるように
    },
  },
  methods: {
    startTimer() {
      if (this.drinkPlanEndTime) {
        this.updateRemainingTime(); // 即時実行
        this.timerId = setInterval(this.updateRemainingTime, 1000);
      }
    },
    updateRemainingTime() {
      const now = new Date().getTime();
      const diff = this.drinkPlanEndTime - now;

      if (diff <= 0) {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
        }
        // 終了扱いにしても表示は "0" のままにする
        this.remainingTime = 0;
        return;
      }

      const minutes = Math.ceil(diff / (1000 * 60));
      this.remainingTime = minutes;
    },
    getMenus() {
      if (!this.user || !this.user.id) return;
      this.axios({
        method: 'GET',
        url: '/v1/menu/get/list',
        params: {
          user_id: this.user.id,
          flags: [1, 2],
        },
      })
        .then((response) => {
          this.tabs = response.data.list.data;
          if (this.tabs.length > 0) {
            this.selectTab(this.tabs[0].id);
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getMenuItems(tabId) {
      if (!this.user || !this.user.id) return;
      const activeTab = this.tabs.find((t) => t.id === tabId);
      const params = {
        user_id: this.user.id,
        flags: [1, 2],
        groupVariants: true,
      };

      if (activeTab && activeTab.name === 'recommended') {
        params.isRecommended = true;
      } else {
        params.menuId = tabId;
      }

      this.axios({
        method: 'GET',
        url: '/v1/menuitem/get/list',
        params,
      })
        .then((response) => {
          this.items = response.data.list.data.map((item) => ({
            ...item,
            isSoldOut: item.flag === 2,
          }));
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getTableSessions() {
      if (!this.user || !this.user.id || !this.diningTableID) return;
      return this.axios({
        method: 'GET',
        url: '/v1/tablesession/get/list',
        params: {
          activeTableId: this.diningTableID,
          user_id: this.user.id,
        },
      })
        .then((response) => {
          this.tablesessions = response.data.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    selectTab(id) {
      this.activeTabId = id;
      this.items = [];
      this.getMenuItems(id);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    showDetail(item) {
      if (item.isSoldOut) return;
      const data = {
        item,
      };
      const args = {
        modalName: 'itemDetail',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
    increaseQuantity(item) {
      this.$store.dispatch('cart/addQuantity', item.id);
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        this.$store.dispatch('cart/subtractQuantity', item.id);
      } else {
        this.$store.dispatch('cart/removeCart', item.id);
      }
    },
    getItemQuantity(itemId) {
      const item = this.cart.find((c) => c.id === itemId);
      return item ? item.quantity : 0;
    },
    confirmOrder() {
      if (this.cart.length === 0) return;
      this.showConfirm('order');
    },
    callStaff() {
      this.showConfirm('called');
    },
    showConfirm(type) {
      const tableSession = this.tablesessions[0];
      if (!tableSession) {
        alert('テーブル情報が取得できませんでした。再度お試しください。');
        this.getTableSessions();
        return;
      }

      const data = {
        cartItems: this.cart,
        uuid: this.uuid,
        diningTableID: this.diningTableID,
        tableSessionID: tableSession.id,
        type,
      };
      const args = {
        modalName: 'Confirm',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
  },
};
</script>

<style scoped>
/* フォント読み込み (FontAwesomeはmain.jsなどで読み込まれている前提) */

.mobile-menu-container {
  font-family: '游明朝体', 'Yu Mincho', 'ヒラギノ明朝 ProN', 'Hiragino Mincho ProN', serif;
  background-image: url('/img/menu/paperboard-texture.jpg');
  background-size: cover;
  min-height: 100vh;
  padding-bottom: 116px; /* フッターの通常時の高さに合わせて調整 */
  color: #333;
}

/* ヘッダー */
.header {
  background-image: url('/img/menu/paperboard-texture.jpg');
  background-size: cover;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-title {
  font-size: 1rem;
  font-weight: bold;
  color: #000;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.header-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(160, 65, 52, 1); /* Menu.vue .checkout と同じ色 */
  color: #fff;
  border: none;
  border-radius: 8px;
  width: 70px;
  height: 50px;
  font-size: 0.7rem;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.header-btn i {
  font-size: 1.2rem;
  margin-bottom: 2px;
}

.header-btn.call-btn {
  background-color: #F4EDE4; /* Menu.vue .call-staff と同じ */
  color: #A63E2F;
  border: 2px solid #A63E2F;
}

/* カテゴリタブ */
.category-tabs-wrapper {
  background-color: #EFEDE4;
  padding: 0 16px 10px;
  position: sticky;
  top: 70px; /* ヘッダーの高さに合わせる */
  z-index: 99;
}

.category-tabs {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: none;
}

.category-tabs::-webkit-scrollbar {
  display: none;
}

.tab-btn {
  padding: 8px 20px;
  border-radius: 20px;
  border: none;
  background-color: #D3C9B6; /* 非アクティブ時の薄い茶色 */
  color: #333;
  font-weight: bold;
  white-space: pre-wrap; /* Allow wrapping */
  text-align: center; /* Ensure text alignment */
  cursor: pointer;
  font-size: 0.9rem;
  min-width: calc(50% - 10px); /* Example fixed width for 3 tabs per row */
  max-width: calc(50% - 5px); /* Example fixed width for 3 tabs per row */
  flex-shrink: 0; /* Prevent shrinking */
  box-sizing: border-box; /* Include padding in width calculation */
  line-height: 1.2;
}

.tab-btn.active {
  background-color: #5D4037; /* アクティブ時の濃い茶色 */
  color: #fff;
}

/* メニューリスト */
.menu-content {
  padding: 10px 16px;
}

.menu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2列 */
  gap: 16px;
}

.menu-grid.list-layout {
  grid-template-columns: 1fr; /* 1列表示 */
  gap: 12px; /* カード間の隙間を調整 */
}

.menu-grid.list-layout .menu-card {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px; 
  /* 角丸や影をリセットしていたスタイルを削除し、通常のカードスタイルを適用 */
}

.menu-grid.list-layout .card-body {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  gap: 16px;
}

.menu-card {
  background-color: #FDFBF7;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  position: relative;
}

.card-image {
  width: 100%;
  height: 120px; /* 高さを固定 */
  background-color: #ddd;
  position: relative;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* アスペクト比を維持したまま要素を覆う */
}

.sold-out-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5; /* 画像の上に表示されるようにz-indexを追加 */
}

.sold-out-overlay span {
  color: #E53935;
  font-weight: bold;
  font-size: 1.5rem;
  border: 3px solid #E53935;
  padding: 5px 10px;
  transform: rotate(-10deg);
  background-color: rgba(255,255,255,0.8);
}

.card-body {
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-name {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.menu-grid.list-layout .item-name {
  margin: 0;
  flex-grow: 1;
  text-align: left;
}

.item-footer {
  display: flex;
  justify-content: flex-end; /* 右寄せに変更 */
  align-items: center;
}

.item-price {
  font-size: 0.9rem;
  font-weight: bold;
}

.menu-grid.list-layout .item-price {
  flex-shrink: 0;
  white-space: nowrap;
}

.tax-included-price {
  font-size: 0.8em;
}

/* 数量バッジ */
.quantity-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #E53935;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.8rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.menu-grid.list-layout .quantity-badge {
  position: static;
  order: 3;
  margin-left: 16px;
}

/* フッター */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column; /* 縦並び */
  justify-content: flex-end; /* 下詰め */
  align-items: stretch; /* 幅いっぱい */
  z-index: 200;
  filter: drop-shadow(0 -2px 5px rgba(0,0,0,0.1));
  transition: all 0.3s ease-in-out;
  height: auto;
  max-height: 116px; /* 通常時の高さ制限: footer-trigger-tab (36px) + footer-main (80px) */
  overflow: hidden; /* 非展開時に上部コンテンツを隠す */
  background-color: transparent; /* 子要素で背景色を設定するため親は透明に */
}

.footer.expanded {
  max-height: 90vh; /* 拡大時の高さ */
  overflow-y: auto; /* expanded時のみスクロール有効化 */
}

/* 開くトリガータブ */
.footer-trigger-tab {
  height: 36px; /* 幅いっぱい */
  background-color: #ccc; /* 背景色を設定 */
  background-size: cover;
  border-radius: 0; /* タブ形状をなくす */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1.2rem;
  position: static; /* position: relative; top: 1px; を削除 */
  border-top: 1px solid #ccc; /* 上部ボーダー */
  border-bottom: none; /* 下部ボーダーを削除してfooter-mainと一体感を出す */
}

.footer-trigger-tab i {
  vertical-align: middle;
}

/* メインフッターコンテンツ (合計金額とボタン) */
.footer-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px 20px; /* iPhone下部考慮 */
  background-image: url('/img/menu/paperboard-texture.jpg');
  background-size: cover;
  height: 80px; /* min-height から height に変更し、高さを固定 */
  z-index: 201;
  border-top: none; /* trigger-tabがボーダーを持つので、mainからは削除 */
}

.footer-expanded-content {
  background-color: #fff;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* コンテナ全体のoverflowはhiddenに */
}

.expanded-title {
  background-color: #fff;
  font-size: 1.1rem;
  font-weight: bold;
  margin: 0;
  text-align: center; /* 中央寄せ */
  flex: 1; /* 残りのスペースを埋めてタイトルが中央に来るように */
  padding: 12px 0;
  border-bottom: none;
}

.cart-details-scroll-area {
  overflow-y: auto; /* スクロール有効化 */
  padding: 10px 0;
  height: 300px; /* 3項目分の高さに固定 (約65px/項目) */
  flex-shrink: 0; /* 高さが縮まないようにする */
}

.empty-cart-message {
  padding: 30px 20px;
  text-align: center;
  color: #888;
}

.cart-list {
  width: 100%;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.cart-item-info {
  text-align: left;
  flex: 1;
}

.cart-item-name {
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.cart-item-price {
  font-size: 0.9rem;
  color: #666;
}

.cart-item-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.qty-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background-color: rgba(160, 65, 52, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  font-size: 0.9rem;
}

.qty-btn:active {
  opacity: 0.8;
}

.qty-display {
  font-weight: bold;
  min-width: 20px;
  text-align: center;
  font-size: 1rem;
}

.total-info {
  display: flex;
  flex-direction: column;
}

.total-label {
  font-size: 0.9rem;
  font-weight: bold;
}

.total-price {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
}

.tax-info {
  font-size: 0.9rem;
  font-weight: normal;
  display: block;
}

.footer-left-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drink-plan-timer {
  background-color: #A63E2F;
  color: white;
  text-align: center;
  padding: 5px 5px;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 5px;
  line-height: 1.2;
}

.drink-plan-timer p {
  margin: 0;
}

.time-value {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0 3px;
}

.confirm-btn {
  background-color: #D9776E; /* Menu.vue .confirm-order と同じ */
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  transform-origin: center;
  transition: background-color 0.3s;
}

.confirm-btn:disabled {
  background-color: #aaa;
  cursor: not-allowed;
  box-shadow: none;
  animation: none; /* disabled時はアニメーションなし */
}

.confirm-btn.can-order {
  animation: bounce-and-blink 1.5s ease-in-out infinite;
}

@keyframes bounce-and-blink {
  0%, 100% {
    transform: scale(1);
    background-color: #E89B94;
  }
  50% {
    transform: scale(1.05);
    background-color: #D9776E;
  }
}

.confirm-icon {
  font-size: 1rem;
}
</style>
